<ng-template [ngIf]="config.name">
  <div class="form-group">
      <ion-label class="form-label">
        {{ config?.label | multiLang: pageService.appLang$.getValue() }}
        <ng-template [ngIf]="config?.required">
          <ion-text color="danger">*</ion-text>
        </ng-template>
      </ion-label>
    
      <ion-datetime
        [formControlName]="config.name"
        [name]="config.name"
        [id]="config.name"
        [displayFormat]="config?.displayFormat"
        [pickerFormat]="config?.pickerFormat"
        [min]="config?.min"
        [max]="config?.max"
        [placeholder]="config?.placeholder | multiLang: pageService.appLang$.getValue()"
        [required]="config?.required ? true : false"
        [pickerOptions]="config?.pickerOptions"
        (ionChange)="onDateChange($event)"
      ></ion-datetime>

    <div *ngIf="control.invalid && control.touched">
      <ion-text *ngIf="control.hasError('required')" color="danger" class="m-b-5">
        <span class="f-12">{{ config.name }} is required</span>
      </ion-text>
    </div>
  </div>
</ng-template>
